// Terminal screen rendered by survey-runner apps (ox-survey, ox-xotski-v2
// DynamicWizard) when a publicly-loaded survey has `lockedReason` set. Keeps
// the message consistent across products without each one re-implementing.
//
// Three reasons live today:
//   - LIMIT_EXHAUSTED  — Free / Starter plan ran out of response slots
//   - PLAN_EXPIRED     — paid plan expired
//   - MANUAL_DISABLE   — admin explicitly disabled the survey

export type SurveyLockedReason =
  | 'LIMIT_EXHAUSTED'
  | 'PLAN_EXPIRED'
  | 'MANUAL_DISABLE';

export interface SurveyLockedScreenProps {
  reason: SurveyLockedReason | string;
  surveyName?: string;
  className?: string;
  messages?: Partial<Record<SurveyLockedReason, string>>;
}

const DEFAULTS: Record<SurveyLockedReason, string> = {
  LIMIT_EXHAUSTED:
    'This survey is no longer accepting responses. Thanks for your interest!',
  PLAN_EXPIRED:
    'This survey is no longer available. Please contact the host for more info.',
  MANUAL_DISABLE:
    'This survey is currently disabled by its administrator.',
};

export function SurveyLockedScreen({
  reason,
  surveyName,
  className,
  messages,
}: SurveyLockedScreenProps) {
  const key = reason as SurveyLockedReason;
  const message = messages?.[key] ?? DEFAULTS[key] ?? DEFAULTS.MANUAL_DISABLE;

  return (
    <div
      role="status"
      data-survey-locked-reason={reason}
      className={className ?? 'plan-sdk-survey-locked'}
    >
      {surveyName && <h2 className="plan-sdk-survey-locked-title">{surveyName}</h2>}
      <p className="plan-sdk-survey-locked-message">{message}</p>
    </div>
  );
}
